import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";

const NameCell: FC<Props> = ({ element }) => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(element.Title ?? ""),
          }}
          className={styles.sender}
        ></div>
      </div>
    </div>
  );
};

export default NameCell;
